function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawYoutubeTutorial = function UndrawYoutubeTutorial(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1130 831.56",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 321.68,
    y1: 857.11,
    x2: 321.68,
    y2: 447.21,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  }))), React.createElement("path", {
    d: "M656.54 124.69C584.1 122.18 515.1 98.78 449.22 73.2S318.07 19.27 247.37 5.71c-45.48-8.72-97.49-9.93-134.13 14.43-35.27 23.46-46.66 64-52.78 101.55-4.61 28.28-7.32 58 5.3 84.51 8.77 18.37 24.34 33.82 35.11 51.42 37.45 61.26 11 136.79-29.62 196.59-19 28.06-41.13 54.82-55.82 84.69s-21.49 64.08-8.64 94.54c12.75 30.2 43.11 52.88 76 68.83 66.81 32.4 145.54 41.68 222.31 46.93 169.95 11.58 340.8 6.58 511.19 1.58 63.06-1.87 126.39-3.76 188.43-13.51 34.44-5.41 70-14 95-34.75 31.75-26.34 39.62-70.94 18.34-104-35.68-55.39-134.35-69.15-159.29-128.6-13.73-32.72.37-69.17 20.32-99.52 42.8-65.11 114.54-122.22 118.32-196.64 2.6-51.11-31.89-102.3-85.21-126.48-55.9-25.35-133.4-22.16-174.64 19.8-42.44 43.21-117.06 59.83-181.02 57.61z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#d0d2d5",
    d: "M664.18 755.89l-195-2.5.57-5 9.43-82.5h171.25l12.6 82.5.96 6.25.19 1.25z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M663.99 754.64h-97.31l-97.5-1.25.57-5h193.28l.96 6.25z"
  }), React.createElement("path", {
    fill: "#d0d2d5",
    d: "M436.68 749.64h258.75v6.25H436.68z"
  }), React.createElement("path", {
    d: "M942.3 170.37a16.27 16.27 0 0 0-16.19-16.35H203.5a16.27 16.27 0 0 0-16.2 16.35v438h755z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M187.3 604.02v51.3a16.2 16.2 0 0 0 16.2 16.2h722.61a16.2 16.2 0 0 0 16.19-16.2v-51.3z",
    fill: "#d0d2d5"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M218.55 181.52H914.8v393.75H218.55z"
  }), React.createElement("path", {
    d: "M568.55 652.05a16.89 16.89 0 0 0 13.28-6.44 17.21 17.21 0 0 0 1.31-1.93l-9.26-1.52 10 .08a16.85 16.85 0 0 0 .32-13.38l-13.43 7 12.39-9.1a16.87 16.87 0 1 0-27.87 18.88 16.87 16.87 0 0 0 13.26 6.41z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M585.43 671.52l77.79 78.12-11.93-78.12h-65.86z"
  }), React.createElement("rect", {
    x: 239,
    y: 252.56,
    width: 457,
    height: 274,
    rx: 2.6,
    fill: "#fff"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M219 181.56h696v23H219z"
  }), React.createElement("rect", {
    x: 222,
    y: 185.56,
    width: 20,
    height: 14,
    rx: 0.78,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 460,
    y: 185.56,
    width: 210,
    height: 14,
    rx: 0.58,
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M663.77 194h-.51l-.19-.16a4.25 4.25 0 0 0 1-2.72 4.14 4.14 0 1 0-4.13 4.17 4.27 4.27 0 0 0 2.72-1l.19.16v.52l3.2 3.2 1-1zm-3.84 0a2.89 2.89 0 1 1 2.88-2.88 2.86 2.86 0 0 1-2.88 2.88z",
    fill: "#444053"
  }), React.createElement("circle", {
    cx: 905,
    cy: 192.56,
    r: 7,
    fill: primaryColor
  }), React.createElement("rect", {
    x: 729,
    y: 229.56,
    width: 65,
    height: 44,
    rx: 2.43,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 229.56,
    width: 84,
    height: 7,
    rx: 0.61,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 244.56,
    width: 84,
    height: 7,
    rx: 0.61,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 259.56,
    width: 84,
    height: 7,
    rx: 0.61,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 729,
    y: 298.56,
    width: 65,
    height: 44,
    rx: 2.43,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 298.56,
    width: 84,
    height: 7,
    rx: 0.61,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 313.56,
    width: 84,
    height: 7,
    rx: 0.61,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 328.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 729,
    y: 367.56,
    width: 65,
    height: 44,
    rx: 2.43,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 367.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 382.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 397.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 729,
    y: 436.56,
    width: 65,
    height: 44,
    rx: 2.43,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 436.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 451.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 466.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 729,
    y: 505.56,
    width: 65,
    height: 44,
    rx: 2.43,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 505.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 520.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("rect", {
    x: 811,
    y: 535.56,
    width: 84,
    height: 7,
    rx: 0.66,
    fill: "#fff"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M304.92 325.17h102.83v5.33H304.92zM314.06 296.99h9.9v28.18h-9.9zM328.53 296.99h9.9v28.18h-9.9zM343 296.99h9.9v28.18H343zM357.47 296.99h9.9v28.18h-9.9zM371.94 296.99h9.9v28.18h-9.9zM386.42 296.99h9.9v28.18h-9.9z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M314.06 302.32h9.9v3.05h-9.9zM328.53 302.32h9.9v3.05h-9.9zM343 302.32h9.9v3.05H343zM357.47 302.32h9.9v3.05h-9.9zM371.94 302.32h9.9v3.05h-9.9zM386.42 302.32h9.9v3.05h-9.9zM314.06 316.03h9.9v3.05h-9.9zM328.53 316.03h9.9v3.05h-9.9zM343 316.03h9.9v3.05H343zM357.47 316.03h9.9v3.05h-9.9zM371.94 316.03h9.9v3.05h-9.9zM386.42 316.03h9.9v3.05h-9.9zM530.37 338.88H633.2v5.33H530.37zM539.51 310.7h9.9v28.18h-9.9zM553.98 310.7h9.9v28.18h-9.9zM568.45 310.7h9.9v28.18h-9.9zM582.93 310.7h9.9v28.18h-9.9zM597.4 310.7h9.9v28.18h-9.9zM611.87 310.7h9.9v28.18h-9.9z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M539.51 316.03h9.9v3.05h-9.9zM553.98 316.03h9.9v3.05h-9.9zM568.45 316.03h9.9v3.05h-9.9zM582.93 316.03h9.9v3.05h-9.9zM597.4 316.03h9.9v3.05h-9.9zM611.87 316.03h9.9v3.05h-9.9zM539.51 329.74h9.9v3.05h-9.9zM553.98 329.74h9.9v3.05h-9.9zM568.45 329.74h9.9v3.05h-9.9zM582.93 329.74h9.9v3.05h-9.9zM597.4 329.74h9.9v3.05h-9.9zM611.87 329.74h9.9v3.05h-9.9zM530.37 377.72H633.2v5.33H530.37zM539.51 349.54h9.9v28.18h-9.9zM553.98 349.54h9.9v28.18h-9.9zM568.45 349.54h9.9v28.18h-9.9zM582.93 349.54h9.9v28.18h-9.9zM597.4 349.54h9.9v28.18h-9.9zM611.87 349.54h9.9v28.18h-9.9z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M539.51 354.87h9.9v3.05h-9.9zM553.98 354.87h9.9v3.05h-9.9zM568.45 354.87h9.9v3.05h-9.9zM582.93 354.87h9.9v3.05h-9.9zM597.4 354.87h9.9v3.05h-9.9zM611.87 354.87h9.9v3.05h-9.9zM539.51 368.58h9.9v3.05h-9.9zM553.98 368.58h9.9v3.05h-9.9zM568.45 368.58h9.9v3.05h-9.9zM582.93 368.58h9.9v3.05h-9.9zM597.4 368.58h9.9v3.05h-9.9zM611.87 368.58h9.9v3.05h-9.9zM368 385.44a28.45 28.45 0 0 1-2.1-3.09l14.81-2.43-16 .12a27.06 27.06 0 0 1-.52-21.38l21.45 11.12-19.81-14.56a27 27 0 1 1 44.57 30.2 26.24 26.24 0 0 1 3.08 4.92l-19.22 10 20.49-6.87a27 27 0 0 1-4.35 25.31 27 27 0 1 1-42.4 0 27 27 0 0 1 0-33.37z"
  }), React.createElement("path", {
    d: "M416.18 402.12a26.89 26.89 0 0 1-5.78 16.66 27 27 0 1 1-42.4 0c-3.63-4.57 48.18-19.69 48.18-16.66z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M393.52 469.66a2.53 2.53 0 0 1 .13.22h-9.16c.05-.07.08-.15.13-.22a8.87 8.87 0 0 1-1.18-4.51 9.26 9.26 0 0 1 .55-3.18c.51.08 1.14.17 1.87.25a32.1 32.1 0 0 0 6.39 0q.92-.09 1.89-.24a.09.09 0 0 0 0 .05 9 9 0 0 1 .54 3.13 8.87 8.87 0 0 1-1.16 4.5z",
    fill: "#3f3d56",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M360.6 469.88h-51c-.11-.29-.21-.6-.3-.9a26.85 26.85 0 0 1 .59-17.64 27 27 0 0 1-9.85-31.89 25.83 25.83 0 0 1-2.91-2.33l13.42-6.69-15.26 4.84a27 27 0 0 1-6.8-20.27l23.81 4.3-23.22-8.07a27 27 0 1 1 51.49 15.7 27.35 27.35 0 0 1 4.43 3.85l-15.42 15.21 17.55-12.62a27 27 0 0 1 3.32 25.5 27 27 0 0 1 10.15 31.01z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M360.6 469.88h-51c-.11-.29-.21-.6-.3-.9a26.85 26.85 0 0 1 .59-17.64c-4.8-3.32 40.23-33.07 41.12-30.17a26.88 26.88 0 0 1-.59 17.65 27 27 0 0 1 10.18 31.06zM591.35 433.34a26.9 26.9 0 0 1-13.51 11.36 27.4 27.4 0 0 1 .11 5.8l-21.61-1.3 21.11 4.58a27 27 0 0 1-3.22 8.16 26.57 26.57 0 0 1-7.2 7.9h-29.42v.77h-30c.06-.26.12-.51.19-.77a27 27 0 0 1 16.45-18.31 27 27 0 0 1 17.13-28.64 27.36 27.36 0 0 1-.22-3.73l13.95 5.51-13.8-8.11a27 27 0 0 1 10.59-18.58l12.71 20.58-9.53-22.66a27 27 0 0 1 36.27 37.44z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M574.23 461.98a26.57 26.57 0 0 1-7.2 7.9h-29.42v.77h-30c.06-.26.12-.51.19-.77a27 27 0 0 1 16.45-18.31c-.25-2 5.56-1.7 13.31-.4 15.19 2.55 37.7 9.09 36.67 10.81z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M446.71 389.97s3.7 20-4.56 26.53 7 45.67 32.18 41.1 35.44-37.4 35.44-37.4-25.22-5.22-15.87-31.75z",
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M446.71 389.97s3.7 20-4.56 26.53 7 45.67 32.18 41.1 35.44-37.4 35.44-37.4-25.22-5.22-15.87-31.75z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 469,
    cy: 362.9,
    r: 41.75,
    fill: "#ee8e9e"
  }), React.createElement("path", {
    d: "M537.61 442.27v28.38H399.75v-27.09a17.48 17.48 0 0 1 10.67-16.1l3.95-1.68c10-4.26 22.15-9.55 26.12-11.75a6.53 6.53 0 0 0 1.22-.79c2.17-2.17 1.74.65 1.74.65s-.06.54-.1 1.47c-.24 6.39.68 31.5 30.11 29.41 28.71-2 30-21.42 29.71-27.13a15.45 15.45 0 0 0-.13-1.58 37.09 37.09 0 0 1 5.81 1.9c6 2.22 14.86 5.78 17.23 7.46.74.52 1.64 1.06 2.62 1.61a17.23 17.23 0 0 1 3.1 2.21 17.51 17.51 0 0 1 5.81 13.03z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M508.85 417.96c-2.43 11.26-10.06 32.35-37.56 32.9-29.3.58-31-28.56-30.81-36.83a5.91 5.91 0 0 0 1.23-.79c2.18-2.17 1.74.65 1.74.65s-3.69 33.27 30 30.88 29.55-28.7 29.55-28.7c0-.16 2.51.71 5.85 1.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M419.58 364.99a7.15 7.15 0 0 1 7.53 2.75c1.52 2.13 1.75 4.7 1.94 7.16 1.81.38 2.83-1.67 3-3.22.67-6.31.72-12.74 2.84-18.84s6.75-12 13.86-14.33a16.08 16.08 0 0 1 7.57-.72c1.51.25 2.93.78 4.43 1 5.2.86 10.85-1.6 15.72.11 3.06 1.08 5 3.57 6.43 6.06a13.08 13.08 0 0 0 2.5 3.63c2.07 1.86 5.31 2.34 8.28 2.92s6.21 1.59 7.48 3.88c1.14 2.07.3 4.46-.08 6.7a16.42 16.42 0 0 0 1.69 10.37c.55 1 1.67 2.21 3 1.88a2.63 2.63 0 0 0 1.42-1.15c3.41-4.78 3.32-11 7.6-15.31 1.43-1.44 3.28-2.56 4.67-4a9.08 9.08 0 0 0 2.42-8.24c-.77-3.3-3.41-6-5.54-8.9a35 35 0 0 1-5.93-12.31 2.23 2.23 0 0 1 0-1.61 4.29 4.29 0 0 1 1.52-1.24 5.74 5.74 0 0 0 1.94-7.33c-1.21-2.47-3.87-4.35-6.87-5.47a44.8 44.8 0 0 0-9.37-2c-2.1.3-4.56-.89-5.21-2.57-.29-.75-.29-1.56-.58-2.31a5.3 5.3 0 0 0-4-2.8 11.7 11.7 0 0 0-5.35.38c-2 .56-4.27 1.4-6 .42-.91-.51-1.41-1.44-2.39-1.86-2-.84-4.06.86-5.49 2.26a13.36 13.36 0 0 1-4.95 3.33 7.37 7.37 0 0 1-6.14-.41c-1.37-.87-2.06-2.27-3.15-3.38a11.86 11.86 0 0 0-7.45-3 26.23 26.23 0 0 0-8.41.92 50.78 50.78 0 0 0-14.77 6.2 15.87 15.87 0 0 0-5.67 5.27 12 12 0 0 0-1.27 5.43c-.22 5.91 1.74 12.13 6.85 16.27-3.12 1.3-4.17 4.49-4.9 7.32-1.17 4.52-2.34 9.11-1.9 13.71.22 2.38.87 4.76.52 7.13a15.36 15.36 0 0 0-.46 3.41 3.27 3.27 0 0 0 2.67 2.49z",
    fill: "#454b69"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M521.23 343.78a9.76 9.76 0 0 1-1.8 2.66c-1.39 1.46-3.24 2.59-4.67 4-4.28 4.28-4.19 10.54-7.6 15.32a2.57 2.57 0 0 1-1.42 1.14c-1.3.34-2.42-.84-3-1.88a17.2 17.2 0 0 1-1.49-4l-.2 1a16.42 16.42 0 0 0 1.69 10.37c.55 1 1.67 2.21 3 1.88a2.63 2.63 0 0 0 1.42-1.15c3.41-4.78 3.32-11 7.6-15.31 1.43-1.44 3.28-2.56 4.67-4a9.08 9.08 0 0 0 2.42-8.24 10.74 10.74 0 0 0-.62-1.79zM511.91 314.18a4.19 4.19 0 0 0-1.52 1.24 2.21 2.21 0 0 0 0 1.6 33.82 33.82 0 0 0 1.51 4.56 5.74 5.74 0 0 0 1.94-7.33 7 7 0 0 0-.7-1.17 5.76 5.76 0 0 1-1.23 1.1zM423.71 323.45a18.54 18.54 0 0 1-6.55-11.59 15.62 15.62 0 0 0-.3 2.72 20.82 20.82 0 0 0 3.29 12.37 7 7 0 0 1 3.56-3.5zM501.08 354.72c.38-2.25 1.22-4.64.08-6.7-1.27-2.3-4.51-3.3-7.48-3.88s-6.21-1.07-8.28-2.92a13.08 13.08 0 0 1-2.5-3.63c-1.41-2.49-3.37-5-6.43-6.06-4.87-1.71-10.52.74-15.72-.11-1.5-.25-2.92-.77-4.43-1a16 16 0 0 0-7.57.72c-7.11 2.34-11.74 8.24-13.86 14.33s-2.17 12.52-2.84 18.84c-.17 1.54-1.19 3.6-3 3.22-.19-2.47-.42-5-1.94-7.17a7.15 7.15 0 0 0-7.53-2.74 3.66 3.66 0 0 1-2.11-1.35 11.59 11.59 0 0 1 0 2.76 15.36 15.36 0 0 0-.46 3.41 3.27 3.27 0 0 0 2.61 2.57 7.15 7.15 0 0 1 7.53 2.75c1.52 2.13 1.75 4.7 1.94 7.16 1.81.38 2.83-1.67 3-3.22.67-6.31.72-12.74 2.84-18.84s6.75-12 13.86-14.33a16.08 16.08 0 0 1 7.57-.72c1.51.25 2.93.78 4.43 1 5.2.86 10.85-1.6 15.72.11 3.06 1.08 5 3.57 6.43 6.06a13.08 13.08 0 0 0 2.5 3.63c2.07 1.86 5.31 2.34 8.28 2.92s6 1.52 7.33 3.64c-.05-.15 0-.3.03-.45zM417.43 351.61a19 19 0 0 0-.33-5.57 24.82 24.82 0 0 0-.19 5.84c0 .5.11 1 .18 1.49.11-.59.26-1.17.34-1.76z"
  })), React.createElement("path", {
    d: "M368.49 511v-18.05a.51.51 0 0 1 .51-.51h2.05a.51.51 0 0 1 .51.51v7.51l8.32-7.71a1.36 1.36 0 0 1 2.23 1v16.35a1.36 1.36 0 0 1-2.23 1l-8.32-7.66v7.47a.51.51 0 0 1-.51.51H369a.51.51 0 0 1-.51-.42zM569.52 492.95V511a.51.51 0 0 1-.52.51h-2a.51.51 0 0 1-.51-.51v-7.51l-8.32 7.7a1.37 1.37 0 0 1-2.24-1v-16.41a1.37 1.37 0 0 1 2.24-1l8.32 7.66v-7.46a.51.51 0 0 1 .51-.51h2a.51.51 0 0 1 .52.48zM465.61 511.78h-4.07a2 2 0 0 1-2-2v-14.94a2 2 0 0 1 2-2h4.07a2 2 0 0 1 2 2v14.94a2 2 0 0 1-2 2zm12.9-2v-14.94a2 2 0 0 0-2-2h-4.11a2 2 0 0 0-2 2v14.94a2 2 0 0 0 2 2h4.07a2 2 0 0 0 2.04-2z",
    fill: "#444053"
  }), React.createElement("path", {
    fill: "#444053",
    opacity: 0.6,
    d: "M349 468.62h240v2.67H349z"
  }), React.createElement("circle", {
    cx: 423.11,
    cy: 469.95,
    r: 6.33,
    fill: "#444053"
  }), React.createElement("path", {
    fill: "#444053",
    d: "M349 468.62h74.11v2.67H349z"
  }), React.createElement("ellipse", {
    cx: 957.08,
    cy: 758.54,
    rx: 59.47,
    ry: 11.44,
    fill: primaryColor
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 753.68,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 742.6,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 731.53,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 720.45,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 709.37,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 698.29,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("ellipse", {
    cx: 956.09,
    cy: 687.21,
    rx: 6.92,
    ry: 9.06,
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M982 611.41a34.28 34.28 0 0 0 2.58-3.8l-18.2-3 19.68.15a33.27 33.27 0 0 0 .63-26.28l-26.38 13.7 24.34-17.89a33.17 33.17 0 1 0-54.78 37.12 33.85 33.85 0 0 0-3.78 6l23.62 12.27-25.18-8.45a33.19 33.19 0 0 0 5.34 31.14 33.16 33.16 0 1 0 52.14 0 33.18 33.18 0 0 0 0-41z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M922.78 631.91a33 33 0 0 0 7.09 20.5 33.16 33.16 0 1 0 52.14 0c4.44-5.63-59.23-24.22-59.23-20.5z",
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 290,
    cy: 810.56,
    rx: 99,
    ry: 21,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M358.15 842.34c-2-.73-4.14-.61-6.23-.84a19.28 19.28 0 0 1-11.46-5.56 21 21 0 0 1-4.58-7c.66.24 1.32.49 2 .76-2-4.67.1-9.91 1.94-14.63q4.68-12 8.85-24.13c7-20.49 13-41.8 12.87-63.6 0-7.88-1.45-15.33-1.73-23.2-.21-5.84.69-11.67.65-17.52 0-.82 0-1.63-.06-2.45a15.53 15.53 0 0 0 5.27-12.66 30.48 30.48 0 0 0-.53-3.68 59.68 59.68 0 0 0-1.4-6.26c-.66-2.17-1.56-4.25-2.33-6.37-1.49-4.11-2.5-8.39-3.77-12.57a4.33 4.33 0 0 1 1.36.37 2.93 2.93 0 0 1-.64-1.31 32.41 32.41 0 0 1-1.2-8.17l.85-.38a21.27 21.27 0 0 0-.41-8.09c.48-4.29 1.23-8.61 1.69-12.88.17-1.6.1-3.61-1.37-4-.3-2.29-.42-4.61-.54-6.92q-.63-12.09-1.25-24.17c-.42-8.09-.84-16.17-1-24.27-.11-5.14-.17-10.46-1.39-15.38a18.6 18.6 0 0 0-.71-7c-1.86-5.89-7.64-10.56-13.5-10.23a26.86 26.86 0 0 0-6.39-6.46c1.17-2.62 2.57-5.32 3.72-7.44 9.38-3.05 16.24-12.3 16.24-23.3a25.43 25.43 0 0 0-2.75-11.59 12.52 12.52 0 0 0 .44-1.35 11.09 11.09 0 0 0-.45-6.49 19 19 0 0 0-1-2.32c-.26-.5-.54-1-.83-1.48L348 459c-.31-.47-.63-.92-1-1.36a33.1 33.1 0 0 0-2.28-2.74 22.56 22.56 0 0 0-3.28-2.92 14.46 14.46 0 0 0-5.4-2.49 16.46 16.46 0 0 0-3.43-.31c-.69 0-1.39 0-2.08.06-1.4.08-2.79.18-4.18.17-.46 0-.93 0-1.39-.07a50.63 50.63 0 0 1-7.24-1.51l-1.2-.25c-.41-.08-.81-.15-1.22-.2a22.89 22.89 0 0 0-3.31-.2h-1.11a30.68 30.68 0 0 0-3.31.34l-1.1.17a31.6 31.6 0 0 0-8.05 2.39c-.33.15-.67.32-1 .5l-.2.11c-.27.14-.54.29-.8.45l-.15.09-.85.54-.07.05c-7.94 5.34-12.63 15.46-13.82 25.5-1.33 11.27 1 22.63 3.33 33.72l2.1 10c.09.45.19.89.28 1.34a22 22 0 0 0-6.59 9.14c-2 5-2.05 10.41-1.89 15.83 0 1.1.06 2.2.17 3.3-.25 2.08-.47 4.17-.61 6.27-.63 9.7.55 19.45.24 29.17-.24 7.49-1.37 15-.82 22.44.48 6.6 2.25 13 4 19.37l2.52 9.08a2.41 2.41 0 0 0 .63 1.25 1.9 1.9 0 0 0 1.41.29 85.12 85.12 0 0 0-4.1 11.48 35.5 35.5 0 0 0-1.48 7.38c-.33 4.58.73 9.13 1.79 13.58q2.4 10 4.78 20.08 1.68 7.05 3.35 14.09c2.2 9.26 4.41 18.58 4.82 28.11a61.05 61.05 0 0 1-1 14.29 124.52 124.52 0 0 0-1.24 42.83 210 210 0 0 0 8.09 35.41c.81-.43 1.63-.83 2.47-1.2l-.35.65q-1.73 3-3.2 6.15a35 35 0 0 0-1.71 4.21c-1.28 4-1.48 8.26-1.66 12.47a6.1 6.1 0 0 0 .21 2.41c.55 1.51 2.13 2.28 3.6 2.7 4.32 1.23 8.81.79 13.3.21a1.61 1.61 0 0 0 .09.29c.55 1.51 2.12 2.28 3.6 2.7 6.18 1.76 12.7.1 19.07-.5s12.63-.16 18.76-1.63a8.93 8.93 0 0 0 2.6-1 8.51 8.51 0 0 0 3.28-4.55 5.83 5.83 0 0 0 .38-1.49c.25-2.19-1.62-4.12-3.6-4.85zM337 749.73a25.2 25.2 0 0 1-2 6.78 129.4 129.4 0 0 0-10.26 32.17 149.15 149.15 0 0 0-2.27 22.25c-.1 5.5.11 11.26-2.18 16.2l.83-.13c-.26.48-.51 1-.75 1.38l-.12.22a21.68 21.68 0 0 1-2.73-7.66c0-.09-.45-.16-1.14-.2a206.93 206.93 0 0 1-2.92-47.89 22.17 22.17 0 0 1 .8-5.75c.51-1.61 1.37-3.08 2-4.64a34.09 34.09 0 0 0 2-8.14 115.64 115.64 0 0 0 1.26-21.52c-.24-6.79 1.33-13.54 2.67-20.3.64-3.21 1.23-6.43 1.55-9.65l.06-.65a96.87 96.87 0 0 1 12.28 31.88 45.6 45.6 0 0 1 .92 15.65zm-42.8-144.52l.32.28a22 22 0 0 1 2.66 2.79 3.69 3.69 0 0 1 .84 1.54c.3 1.46-.91 2.7-1.9 3.77a17 17 0 0 0-1.21 1.46q-.32-4.92-.68-9.84z",
    transform: "translate(-35 -34.22)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M245.36 508.31l-1.1 8.49c-.37 2.88-.74 5.75-.94 8.64-.67 9.62.57 19.28.25 28.92-.26 7.42-1.44 14.83-.87 22.24.51 6.54 2.37 12.9 4.23 19.2l2.64 9a2.38 2.38 0 0 0 .66 1.24 2.33 2.33 0 0 0 1.69.27l11.72-1.06c-.75-3.44-1.58-7-2-10.53-.32-2.76-.51-5.54-.71-8.32-.62-8.66-1.33-17.32-2-26l-1.25-15.2c-.53-6.6-1.08-13.23-2.74-19.64a39.09 39.09 0 0 0-9.58-17.25z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M245.36 508.31l-1.1 8.49c-.37 2.88-.74 5.75-.94 8.64-.67 9.62.57 19.28.25 28.92-.26 7.42-1.44 14.83-.87 22.24.51 6.54 2.37 12.9 4.23 19.2l2.64 9a2.38 2.38 0 0 0 .66 1.24 2.33 2.33 0 0 0 1.69.27l11.72-1.06c-.75-3.44-1.58-7-2-10.53-.32-2.76-.51-5.54-.71-8.32-.62-8.66-1.33-17.32-2-26l-1.25-15.2c-.53-6.6-1.08-13.23-2.74-19.64a39.09 39.09 0 0 0-9.58-17.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M266.24 797.33a35.81 35.81 0 0 0-1.8 4.18c-1.34 3.95-1.54 8.19-1.74 12.36a6 6 0 0 0 .22 2.39c.58 1.5 2.24 2.26 3.79 2.67 6.49 1.75 13.33.11 20-.49s13.26-.16 19.7-1.61a10.06 10.06 0 0 0 2.73-.95 8.51 8.51 0 0 0 3.45-4.5 5.88 5.88 0 0 0 .39-1.48c.21-2.2-1.7-4.1-3.78-4.82s-4.35-.61-6.54-.83a20.6 20.6 0 0 1-18.24-17.21c-.08-.48-10.84-.19-12 .43-1.32.73-2.12 2.54-2.87 3.77q-1.77 2.97-3.31 6.09z",
    fill: "#a26565"
  }), React.createElement("path", {
    d: "M266.24 797.33a35.81 35.81 0 0 0-1.8 4.18c-1.34 3.95-1.54 8.19-1.74 12.36a6 6 0 0 0 .22 2.39c.58 1.5 2.24 2.26 3.79 2.67 6.49 1.75 13.33.11 20-.49s13.26-.16 19.7-1.61a10.06 10.06 0 0 0 2.73-.95 8.51 8.51 0 0 0 3.45-4.5 5.88 5.88 0 0 0 .39-1.48c.21-2.2-1.7-4.1-3.78-4.82s-4.35-.61-6.54-.83a20.6 20.6 0 0 1-18.24-17.21c-.08-.48-10.84-.19-12 .43-1.32.73-2.12 2.54-2.87 3.77q-1.77 2.97-3.31 6.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M284.09 800.51a34 34 0 0 0-1.8 4.17c-1.35 4-1.55 8.19-1.74 12.36a5.83 5.83 0 0 0 .22 2.39c.57 1.5 2.23 2.26 3.78 2.68 6.49 1.74 13.34.1 20-.5s13.27-.16 19.7-1.61a9.62 9.62 0 0 0 2.73-1 8.47 8.47 0 0 0 3.45-4.5 5.88 5.88 0 0 0 .39-1.48c.21-2.19-1.7-4.1-3.78-4.82s-4.35-.6-6.54-.83a20.61 20.61 0 0 1-18.24-17.2c-.08-.48-10.84-.2-12 .42-1.33.73-2.13 2.54-2.88 3.77-1.14 2.03-2.26 4.07-3.29 6.15z",
    fill: "#a26565"
  }), React.createElement("path", {
    d: "M330.62 694.28c.14 21.61-6.14 42.73-13.51 63q-4.38 12.06-9.29 23.91c-1.94 4.68-4.13 9.88-2.05 14.5-6-2.28-12.1-3.62-18.41-2.57 2.4-4.9 2.17-10.6 2.28-16a140.3 140.3 0 0 1 2.36-22.05 123 123 0 0 1 10.79-31.89 24.3 24.3 0 0 0 2.09-6.72c.82-5.14.18-10.42-.89-15.51a92.47 92.47 0 0 0-12.9-31.6l-.06.64a93.27 93.27 0 0 1-1.62 9.57c-1.41 6.69-3.06 13.39-2.81 20.12a108.83 108.83 0 0 1-1.32 21.33 32.43 32.43 0 0 1-2.15 8.06c-.69 1.55-1.59 3-2.13 4.61a21 21 0 0 0-.84 5.7c-.8 16.27 0 32.79 3.32 48.74-5.57-.44-11.14 1.17-16.12 3.67a198.54 198.54 0 0 1-8.5-35.1 116.62 116.62 0 0 1 1.3-42.46 56.42 56.42 0 0 0 1.05-14.15c-.43-9.45-2.75-18.69-5.06-27.87l-3.52-14q-2.5-10-5-19.91c-1.11-4.41-2.23-8.92-1.88-13.46a33.4 33.4 0 0 1 1.56-7.32 81.69 81.69 0 0 1 11.07-22.64c19.27 1.08 38.77-.72 58-2.2a3.89 3.89 0 0 1 2.72.46 3.85 3.85 0 0 1 1.1 2.48l7.23 41a103 103 0 0 1 2.05 17.3c0 5.8-.9 11.58-.68 17.37.3 7.8 1.78 15.18 1.82 22.99z",
    fill: "#454b69"
  }), React.createElement("path", {
    d: "M291.05 669.99a93.27 93.27 0 0 1-1.62 9.57c-4.19-7.25-8.71-14.32-12.57-21.75-1-1.91-1.94-3.85-2.89-5.79l-2.85-5.8c-.53-1.09-1.06-2.18-1.54-3.29a23.77 23.77 0 0 1-1.79-5c1.4-.26 4.86 3.52 5.9 4.51a80.64 80.64 0 0 1 6 6.64 72.81 72.81 0 0 1 6.26 8.2 39.88 39.88 0 0 1 5.1 12.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M307.1 471.08s-10.7 17.05-8.72 20.62-33.7-3.17-33.7-3.17 19.43-17.05 17.44-24.19 24.98 6.74 24.98 6.74z",
    fill: "#efb7b9"
  }), React.createElement("circle", {
    cx: 297.59,
    cy: 452.05,
    r: 24.19,
    fill: "#efb7b9"
  }), React.createElement("path", {
    d: "M307.46 488.96a24.56 24.56 0 0 0-10.17-8.18 36.38 36.38 0 0 0-7.23-1.78l-9.65-1.7c-2.36-.42-4.89-.81-7.09.16a11.62 11.62 0 0 0-3 2.21c-3.35 3.11-6.6 6.52-10.81 8.32-1.15.49-2.35.85-3.5 1.34-4.71 2-8.23 6.26-10.22 11-2.1 4.94-2.16 10.31-2 15.68a27.56 27.56 0 0 0 .55 5.52 35.57 35.57 0 0 0 1.83 5.06 92.57 92.57 0 0 1 3.34 10.73q3.75 14.35 6.24 29a10.87 10.87 0 0 0 1.21 4 14.36 14.36 0 0 0 3.34 3.21 20.86 20.86 0 0 1 2.79 2.77 3.62 3.62 0 0 1 .91 1.48c.31 1.44-1 2.68-2 3.73a18.06 18.06 0 0 0-4.52 7.87 3.17 3.17 0 0 0-.72 2.17 3.8 3.8 0 0 1 .23 1.72 3.88 3.88 0 0 1-.91 1.41 5.33 5.33 0 0 0-1 4.28 67.89 67.89 0 0 0 23.68 5.54c2 .1 4 .1 6 .34 1.42.18 2.82.47 4.24.64a45.78 45.78 0 0 0 6.2.16c10.77-.22 21.85-.49 31.74-4.76.93-5.07-1.08-10.24-2.34-15.24-2-8-2.5-16.19-4-24.26-1-5.51-2.5-10.94-3.35-16.49s-1-11.3.48-16.7c1.35-4.78 1.76-9.66 3.16-14.43s2.38-9.94.8-14.66c-2-5.84-8.07-10.47-14.23-10.14z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M319.34 439.22c1.18-4.29-1.14-8.76-3.9-12.25-3-3.75-6.82-7.13-11.51-8.07-3.81-.77-7.76.16-11.64-.15-3.43-.27-6.73-1.51-10.14-2a32.12 32.12 0 0 0-9.28.35 35.25 35.25 0 0 0-8.45 2.36c-10.3 4.57-16.33 15.83-17.73 27s1.05 22.43 3.49 33.42l2.21 9.94c2.3 10.35 4.6 20.74 5.21 31.32s-.53 21.44-4.88 31.1a66.89 66.89 0 0 0 30.73-34.79c1.56-4.09 2.72-8.34 4.46-12.36 1.49-3.46 3.4-6.74 4.72-10.27a33.36 33.36 0 0 0 2.11-12.47c-.08-3.2-.61-6.38-.52-9.58s.91-6.53 3.12-8.85c2-2.05 4.75-3 7.28-4.33a30.31 30.31 0 0 0 10.19-8.5c1.59-2.08 1.68-3 2.08-5.36s1.83-4.24 2.45-6.51z",
    fill: "#a26565"
  }), React.createElement("path", {
    d: "M319.37 620.93c.25 2.49-.2 5 .34 7.47.41 1.84 1.36 3.5 1.92 5.3a25.2 25.2 0 0 1 .85 6.37c.08 1.8-.06 4-1.66 4.84-.7.37-1.54.37-2.27.69s-1.35 1.19-.93 1.87 1.14.57 1.8.7 1.37.81 1 1.36a1.14 1.14 0 0 1-.58.37 7.08 7.08 0 0 0-1.88.9 1.92 1.92 0 0 0-.77 1.83 1.13 1.13 0 0 0 1.61.74 5 5 0 0 0-.47 2c2.56 1.1 5.43-.34 7.83-1.73a29.49 29.49 0 0 0 3-1.92 15 15 0 0 0 5.84-12.77 29.79 29.79 0 0 0-.57-3.65 54.92 54.92 0 0 0-1.47-6.21c-.69-2.15-1.63-4.2-2.44-6.31-1.72-4.49-2.83-9.19-4.39-13.74a2.08 2.08 0 0 0-.75-1.19 2.11 2.11 0 0 0-1.11-.21 18.19 18.19 0 0 0-5.21.48c-1 .3-2.71 1-3.18 2s.28 1.84.73 2.67a22.38 22.38 0 0 1 2.76 8.14z",
    fill: "#efb7b9"
  }), React.createElement("path", {
    d: "M317.74 499.42a7.33 7.33 0 0 1 1.28 1.78c3.44 6.25 3.48 13.72 3.64 20.85.18 8 .62 16 1.06 24.05l1.31 24c.13 2.29.25 4.58.58 6.85 1.54.39 1.6 2.39 1.43 4-1.11 9.78-3.86 19.85-1 29.26a2.94 2.94 0 0 0 .67 1.3 7.81 7.81 0 0 0-4.47-.06c-1.43.3-2.81.83-4.25 1.16-1.82.41-3.88.59-5.12 2a99.24 99.24 0 0 1-3.35-12.92c-.68-4-.87-8.12-2.49-11.82-.65-1.49-1.53-2.87-2.33-4.3-4.19-7.48-6.25-15.93-8.26-24.27a35.43 35.43 0 0 1-.64-12.06 41.47 41.47 0 0 0 .5-5.55 42.64 42.64 0 0 0-.77-5.84 39.15 39.15 0 0 1 1.17-16.91c1.5-5.09 2.82-10.45 6-14.73s9.73-6.72 15.04-6.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M318.93 498.62a7.39 7.39 0 0 1 1.28 1.79c3.44 6.24 3.48 13.72 3.64 20.85.18 8 .62 16 1.06 24l1.31 24c.13 2.29.25 4.58.58 6.85 1.54.39 1.6 2.39 1.42 4-1.1 9.78-3.85 19.84-1 29.26a2.94 2.94 0 0 0 .67 1.3 7.81 7.81 0 0 0-4.47-.06c-1.43.3-2.81.83-4.25 1.15-1.82.42-3.88.59-5.12 2a98.21 98.21 0 0 1-3.32-12.98c-.68-4-.87-8.11-2.49-11.81a48.28 48.28 0 0 0-2.33-4.3c-4.2-7.48-6.25-15.94-8.26-24.28a35.42 35.42 0 0 1-.64-12.06 26 26 0 0 0-.27-11.39 39.1 39.1 0 0 1 1.17-16.9c1.5-5.09 2.82-10.45 6-14.73s9.71-6.61 15.02-6.69z",
    fill: primaryColor
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M315.44 426.97c-3-3.75-6.82-7.13-11.51-8.07-3.81-.77-7.76.16-11.64-.15-3.43-.27-6.73-1.51-10.14-2a32.12 32.12 0 0 0-9.28.35 35.25 35.25 0 0 0-8.45 2.36 25.09 25.09 0 0 0-4.17 2.37 35.56 35.56 0 0 1 7.47-2 32 32 0 0 1 9.27-.35c3.42.44 6.71 1.67 10.15 1.94 3.87.31 7.82-.61 11.64.15 4.69.94 8.53 4.33 11.5 8.08 2.77 3.48 5.08 7.95 3.91 12.25-.62 2.26-2.06 4.24-2.45 6.57s-.49 3.28-2.09 5.36a30.38 30.38 0 0 1-7.34 6.83c.77-.36 1.56-.72 2.31-1.11a30.31 30.31 0 0 0 10.19-8.5c1.59-2.08 1.68-3 2.08-5.36s1.83-4.3 2.45-6.57c1.18-4.19-1.14-8.66-3.9-12.15zM297.34 463.98a10 10 0 0 1 1.35-1.17c-2.31 1.12-4.74 2.1-6.51 4-2.21 2.31-3 5.65-3.12 8.85s.45 6.38.52 9.57a33.41 33.41 0 0 1-2.11 12.48c-1.32 3.53-3.23 6.8-4.72 10.27-1.73 4-2.89 8.26-4.45 12.35a67 67 0 0 1-25.41 31.62c-.06.13-.11.27-.17.4a66.89 66.89 0 0 0 30.73-34.79c1.56-4.09 2.72-8.34 4.46-12.36 1.49-3.46 3.4-6.74 4.72-10.27a33.36 33.36 0 0 0 2.11-12.47c-.08-3.2-.61-6.38-.52-9.58s.91-6.58 3.12-8.9z"
  })));
};
UndrawYoutubeTutorial.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawYoutubeTutorial;